import React, { useEffect, useState, useRef } from 'react';
import axios, { formToJSON } from 'axios';
import { useParams } from 'react-router-dom';
import $, { data } from 'jquery';
import 'select2';
import '../css/Select2.css';
import '../css/Login.css';
import '../css/Materialize.css';
import '../css/Style.css';
import '../css/new.css';
import reloadToken from '../helper/reloadtoken';
import helperFilter from '../helper/helperfilter';
import HeaderMenu from '../template/HeaderMenu';
import { apiConfig } from '../helper/apiConfig';
import { hide, sumDataKerja, getFrozen, createRatioZoom, getRatioZoom, saveheighrow, getheighrow, removeComma, getFilterPageAll, getFilterPageAllJson } from '../helper/hide';
import { ToastContainer, toast } from 'react-toastify';
import { dataconfig, showtoolbarConfig } from '../helper/luckysheetHelper';
import 'react-toastify/dist/ReactToastify.css';
import Modal from './modal_doc_perusahaan';
import Modalpreview from './modalpreview';
import Convertformatlucky from '../helper/convertformatlucky';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Message from '../helper/messages';
import { encrypt, decrypt, AesEncrypt } from '../helper/Decrypte';
import messages from '../helper/messages';
import { faArrowLeft, faSearch } from '@fortawesome/free-solid-svg-icons';

const title_form = "DATA PERUSAHAAN / GROUP";
const sub_title_form = ""
const tipedata = "PERUSAHAAN";
const historyback = 'perusahaan'
const mainhost = process.env.REACT_APP_API_HOST_MASTER;
const hostcc = process.env.REACT_APP_API_HOST_COLOR_COMMENT;
const hostdrop = process.env.REACT_APP_API_HOST_DROPDOWN;
const hostdatcont = process.env.REACT_APP_API_HOST_DATA_CONT;

const API_Datainout = mainhost + "DatainoutData"
const API_NewDatainout = mainhost + "DatainoutNew"
const API_ActiveDatainout = mainhost + "DatainoutActive"
const API_PercentDatainout = mainhost + "DatainoutPercent"
const API_PT_DROPDOWN = mainhost + "PerusahaanForDropdown"

const API_DatainoutList = mainhost + "DatainoutList"
const API_DatainoutReportToko = mainhost + "DatainoutReportToko"
const API_AssetReportAllDivisionToko = mainhost + "AssetReportAllDivisionToko"
const API_AssetReportAllDivision = mainhost + "AssetReportAllDivision"
const API_AssetReportPusatToko = mainhost + "AssetReportPusatToko"


const currentUrl = window.location.href;

const notify_cant_update_br_cont = (message, time = 800) => {
  toast.error(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const notify_update_br_cont = (message, time = 2000) => {
  toast.success(<div dangerouslySetInnerHTML={{ __html: message }} />, {
    position: toast.POSITION.TOP_CENTER,
    autoClose: time,
  });
};

const ReportCross = () => {
  const token = localStorage.getItem('token');

  const [TokenNew, setToken] = useState(null);
  const [DatainoutData, setDatainoutData] = useState(null);
  const [DatainoutReportToko, setDatainoutReportToko] = useState(null);
  const [ReportAllDivisionToko, setReportAllDivisionToko] = useState(null);
  const [AssetReportAllDivision, setAssetReportAllDivision] = useState(null);
  const [ReportPusatToko, setReportPusatToko] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const config = apiConfig(token);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);
  const current_month = new Date().getMonth() + 1;

  const selectForBln = useRef(null);
  const selectForYearh = useRef(null);

  const year_local = localStorage.getItem("year_selected");
  const month_local = localStorage.getItem("month_selected");

  const year_selected = year_local ?  parseInt(year_local) : years[0]
  const month_selected = month_local ? parseInt(month_local) : current_month

  const [selectedYear, setSelectedYear] = useState(year_selected);
  const [selectedMonth, setSelectedMonth] = useState(month_selected);

  const months = [
    { value: '1', label: 'Januari' },
    { value: '2', label: 'Februari' },
    { value: '3', label: 'Maret' },
    { value: '4', label: 'April' },
    { value: '5', label: 'Mei' },
    { value: '6', label: 'Juni' },
    { value: '7', label: 'Juli' },
    { value: '8', label: 'Agustus' },
    { value: '9', label: 'September' },
    { value: '10', label: 'Oktober' },
    { value: '11', label: 'November' },
    { value: '12', label: 'Desember' },
  ];
  

  const fetchDropdownOptions = async () => {
    try {
      const config = apiConfig(token);
      const response = await axios.post(`${API_PT_DROPDOWN}`, null, config);
      return response.data;
    } catch (error) {
      console.error('Error fetching column names:', error);
      return [];
    }
  };

  const getDatainoutData = async () => {
    try {

      const formData = new FormData();
        formData.append('bln',month_selected);
        formData.append('thn',year_selected);
        // formData.append('email', user);
        // formData.append('password', pass);
        const response = await axios.post(`${API_Datainout}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_DatainoutReportToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportAllDivisionToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportAllDivisionToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportPusatToko = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportPusatToko}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const getReportAllDivision = async () => {
    try {

      const formData = new FormData();
      formData.append('bln',month_selected);
      formData.append('thn',year_selected);
      const response = await axios.post(`${API_AssetReportAllDivision}`, formData, config);
      const data = response.data;
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleNewDatainout = async () => {
    const newDatainout = document.getElementById('new_asset').value;
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append('asset', newDatainout);
      const response = await axios.post(`${API_NewDatainout}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
      const asset_data = await getDatainoutData();
      setDatainoutData(asset_data);
      setIsLoading(false);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const handleActiveDatainout = async (id) => {
    setIsLoading(true);
    DatainoutData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.active);
        if (item.active === '1') {
          item.active = '0';
        }
        else {
          item.active = '1';
        }
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      const response = await axios.post(`${API_PercentDatainout}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleChange = () => {

  }

  const handleMonthChange = (event) => {
    const value = event.target.value;
    let intValue;
    if (value.trim() !== '') {
         intValue = parseInt(value, 10);
        if (!isNaN(intValue)) {
        } else {
          intValue="";
        }
    } else {
      intValue="";
    }
    setSelectedMonth(intValue);
    localStorage.setItem("month_selected", intValue);
    window.location.reload();
  }

  const handleSelectYearChange = (year) => {
    const value = year.target.value;
    let intValue = parseInt(value, 10);
    if (!isNaN(intValue)) {
      setSelectedYear(intValue); // Update selected year state
      localStorage.setItem("year_selected", intValue); // Store in local storage
    } else {
      setSelectedYear(""); // Reset selected year state
      localStorage.removeItem("year_selected"); // Remove from local storage
    }
    window.location.reload();
  }

  const handlePercentDatainout = async (id,e) => {
    console.log(e.target.value);
    console.log(id);
    setIsLoading(true);
    DatainoutData.map((item) => {
      console.log(item);
      if (item.id === id) {
        console.log(item.percentage);
        item.percentage = e.target.value;
      }
    });
    setIsLoading(false);
    try {
      const formData = new FormData();
      formData.append('id', id);
      formData.append('percentage', e.target.value);
      const response = await axios.post(`${API_PercentDatainout}`, formData, config);
      const data = response.data;
      console.log(data);
      if (data.status === 200) {
        notify_update_br_cont(data.message);
        document.getElementById('new_asset').value = '';
      } else {
        notify_cant_update_br_cont(data.message);
      }
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  $(selectForBln.current).on('change', handleMonthChange);
  $(selectForYearh.current).on('change', handleSelectYearChange);

  useEffect(() => {
    setIsLoading(true);
    //TYPE
    $('.js-example-basic-single').select2();
    $('.js-example-basic-multiple').select2({
      theme: "classic"
    });

    const getIdFromUrl = () => {
      const urlParts = window.location.href.split('/');
      const id = urlParts[urlParts.length - 1];
      return id;
    };
    // const intervalId = setInterval(cekFile, 3600000);//1 jam

    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 100));
      const newToken = await reloadToken();
      setToken(newToken);
      // const asset_data = await getDatainoutData();
      // setDatainoutData(asset_data);
      // const report_toko = await getReportToko();
      // setDatainoutReportToko(report_toko);
      const sum_report_allDivision = await getReportAllDivisionToko();
      setReportAllDivisionToko(sum_report_allDivision);
      const sumarry_report_toko = await getReportAllDivision();
      setAssetReportAllDivision(sumarry_report_toko);
      const summary_pusat_toko = await getReportPusatToko();
      setReportPusatToko(summary_pusat_toko);
      setIsLoading(false);
    };

    new Promise((resolve) => setTimeout(resolve, 100));

    function isMobileDevice() {
      const mobileScreenWidth = 768;
      return window.innerWidth < mobileScreenWidth;
    }

    setTimeout(function () {
      var calcChainLength = 0;
      console.log('asset',DatainoutData);

    }, 1500);

    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    } else {
      // If token is not found in localStorage, reload it
      reloadToken().then(newToken => {
        setToken(newToken);
        // Store the token in localStorage for future use
        localStorage.setItem('token', newToken);
      });
    }

    fetchData();
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('Tab is hidden');
        // luckysheet.refresh();
      } else {
        console.log('Tab is visible');
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      // clearInterval(intervalId);

      $(selectForBln.current).on('change', handleMonthChange);
      $(selectForYearh.current).on('change', handleSelectYearChange);
    };
  }, []);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const formatNumberWithoutDecimals = (num) => {
    // convert num into float
    num = parseFloat(num);
    if (isNaN(num)) {
      return '0';
    }
    return num.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  };
  const selectStyle120 = {
    // Define your custom CSS styles here
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '2px',
    fontSize: '16px',
    width: '120px',
    height: '10%',
    marginTop: '5px',
  };
  const labelStyel = {
    marginTop: '22px',
  };
  const randomKey = () => {
    return Math.random().toString(36).substr(2, 9);
  }
  return (
    <div>
      <HeaderMenu title={"Report All Divisi"} subtitle={"Report All Divis"} />
      {/* <ToastContainer /> */}
      
      <div style={{ textAlign: 'center' }}>
        <table border={0}>
          <thead>
          </thead>
          <tbody>
            <tr>
              <td>
                <select style={selectStyle120} ref={selectForBln} className="js-example-basic-single style-select-report" value={selectedMonth || ""} onChange={handleChange}>
                <option value="">-PILIH-</option>
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>
              </td>
              <td>
              <select style={selectStyle120} ref={selectForYearh} className="js-example-basic-single style-select-report" value={selectedYear} onChange={handleChange}>
                  <option value="">-PILIH-</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </td>  
            </tr>
          </tbody>
        </table>

      </div>
      <div className="containers" style={{ width : "100%"}}>

        <ul className="tabs" style={{ width: "100%"}}>
          <li className="tab-link" data-tab="tab-1">Summary</li>
          {/* <li className="tab-link" data-tab="tab-2">Sum</li> */}
          <li className="tab-link current" data-tab="tab-3">Report</li>
        </ul>


        <div id="tab-1" className="tab-content current">
          <div style={{ textAlign: 'center', overflow:'auto', height:'100%', width:'100%'}}>
            <table className='table table-bordered' style={{ width:"1648px", marginRight:"20px"}}>
              <thead>
                <tr>
                  <th rowSpan={2}>Asset</th>
                  <th rowSpan={2}>Maintenance Rek</th>
                  <th colSpan={5}>Operasional</th>
                  <th colSpan={4}>Gaji Karyawan</th>
                  <th colSpan={4}>Kasbon</th>
                </tr>
                <tr>
                  
                  <th>Operasional</th>
                  <th>Tele</th>
                  <th>Finance</th>
                  <th>Marketing</th>
                  <th>Jenius</th>
                  {/* <th>Total</th> */}

                  <th>Operasional</th>
                  <th>Tele</th>
                  <th>Finance</th>
                  <th>Marketing</th>
                  {/* <th>Total</th> */}

                  <th>Operasional</th>
                  <th>Tele</th>
                  <th>Finance</th>
                  <th>Marketing</th>
                  {/* <th>Total</th> */}
                </tr>
              </thead>
              <tbody>
              { isLoading ? <tr><td>Loading...</td></tr> :
              AssetReportAllDivision && AssetReportAllDivision.map((category,categoryIndex) => (

                Object.keys(category).map((item,index) => (
                  <tr key={randomKey+"tr"}>
                    <td key={randomKey+item}  style={{ textAlign:"left", width:"120px"  }}>{item}</td>
                    <td key={randomKey+"maintain"} style={{ textAlign:"right", width:"100px"  }}>{category[item]?.MaintenanceRek?.Total ? formatNumberWithoutDecimals(category[item]["MaintenanceRek"]["Total"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.OPERASIONAL ? formatNumberWithoutDecimals(category[item]["Operasional"]["OPERASIONAL"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.TELE ? formatNumberWithoutDecimals(category[item]["Operasional"]["TELE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.FINANCE ? formatNumberWithoutDecimals(category[item]["Operasional"]["FINANCE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.MARKETING ? formatNumberWithoutDecimals(category[item]["Operasional"]["MARKETING"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.Jenius ? formatNumberWithoutDecimals(category[item]["Operasional"]["Jenius"]) : ''}</td>
                    {/* <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Operasional?.Finance ? formatNumberWithoutDecimals(category[item]["Operasional"]["Total"]) : ''}</td> */}

                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.GajiKaryawan?.OPERASIONAL ? formatNumberWithoutDecimals(category[item]["GajiKaryawan"]["OPERASIONAL"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.GajiKaryawan?.TELE ? formatNumberWithoutDecimals(category[item]["GajiKaryawan"]["TELE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.GajiKaryawan?.FINANCE ? formatNumberWithoutDecimals(category[item]["GajiKaryawan"]["FINANCE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.GajiKaryawan?.MARKETING ? formatNumberWithoutDecimals(category[item]["GajiKaryawan"]["MARKETING"]) : ''}</td>
                    {/* <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.GajiKaryawan?.Finance ? formatNumberWithoutDecimals(category[item]["GajiKaryawan"]["Total"]) : ''}</td> */}

                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Kasbon?.OPERASIONAL ? formatNumberWithoutDecimals(category[item]["Kasbon"]["OPERASIONAL"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Kasbon?.TELE ? formatNumberWithoutDecimals(category[item]["Kasbon"]["TELE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Kasbon?.FINANCE ? formatNumberWithoutDecimals(category[item]["Kasbon"]["FINANCE"]) : ''}</td>
                    <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Kasbon?.MARKETING ? formatNumberWithoutDecimals(category[item]["Kasbon"]["MARKETING"]) : ''}</td>
                    {/* <td style={{ textAlign:"right", width:"100px" }}>{category[item]?.Kasbon?.Finance ? formatNumberWithoutDecimals(category[item]["Kasbon"]["Total"]) : ''}</td> */}
                    
                  </tr>
                  
                ))
              ))
              }
            </tbody>
            </table>
            </div>
        </div>
        <div id="tab-2" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'100%', width:'100%'}}>
            <table className=''>
              <tbody>
                <tr>
                  
              { isLoading ? <tr><td>Loading...</td></tr> :
              ReportAllDivisionToko && ReportAllDivisionToko.map((category,categoryIndex) => (

              Object.keys(category).map((item,index) => (
                <td style={{ verticalAlign:'top'}}><table style={{ width: "240px", float:"left"}} className='table table-bordered'>
                  <tbody>
                <tr key={randomKey+"tr"}>
                  <td colSpan="2" key={randomKey+item}>{item}</td>
                </tr>
                  {category[item] && Object.keys(category[item]).map((item2,index2) => (
                    <tr>
                      <td style={{ textAlign:'left'}}>{item2}</td>
                      <td style={{ textAlign:'right'}}>{formatNumberWithoutDecimals(category[item][item2])}</td>
                    </tr>
                    
                  ))}
                  </tbody>
                  </table>
                  </td>
                ))
              ))}
              </tr>
            </tbody>
            </table>
            </div>
        </div>
        <div id="tab-3" className="tab-content">
          <div style={{ textAlign: 'center', overflow:'auto', height:'540px', width:'100%'}}>
            <table className=''>
              <tbody>
                <tr>
                  
              { isLoading ? <tr><td>Loading...</td></tr> :
              ReportPusatToko && ReportPusatToko.map((category,categoryIndex) => (

              Object.keys(category).map((item,index) => (
                <td style={{ verticalAlign:'top'}}><table style={{ width: "300px", float:"left"}} className='table table-bordered'>
                  <tbody>
                <tr key={randomKey+"tr"}>
                  <td colSpan="3" key={randomKey+item}>{item}</td>
                </tr>
                <tr>
                  <td>P.Cash</td>
                  <td>Account</td>
                  <td>Jumlah</td>
                </tr>
                  {category[item] && Object.keys(category[item]).map((item2,index2) => (
                    category[item][item2] && Object.keys(category[item][item2]).map((item3,index3) => (
                      <tr>
                        <td style={{ textAlign:'left'}}>{item2}</td>
                        <td style={{ textAlign:'left'}}>{item3}</td>
                        <td style={{ textAlign:'right'}}>{formatNumberWithoutDecimals(category[item][item2][item3])}</td>
                      </tr>
                    ))
                  ))}
                  </tbody>
                  </table>
                  </td>
                ))
              ))}
              </tr>
            </tbody>
            </table>
            </div>
        </div>
      </div>

    </div>
  );
};


export default ReportCross;